(function () {
  const SOURCE_ID = 'new-window-note-source';

  function cloneNewWindowNote() {
    const source = document.getElementById(SOURCE_ID);
    if (!source) return null;
    return source.firstElementChild?.cloneNode(true) ?? null;
  }

  function augmentBlankLinks(root) {
    if (!root || root.nodeType !== 1) return;

    const links = [];
    if (root.matches('a[target="_blank"]')) {
      links.push(root);
    }
    root.querySelectorAll('a[target="_blank"]').forEach((link) => {
      links.push(link);
    });

    links.forEach((link) => {
      if (link.querySelector('.new-window-note')) return;
      const note = cloneNewWindowNote();
      if (note) link.appendChild(note);
    });
  }

  function init() {
    if (!document.body) return;

    augmentBlankLinks(document.body);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            augmentBlankLinks(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
